// extracted by mini-css-extract-plugin
export default {"box":"UnblockUser_box__t8RfY","selectTitle":"UnblockUser_selectTitle__G4P+i","title":"UnblockUser_title__GC50O","inputTitle":"UnblockUser_inputTitle__+k76B"};